function removeGeneratedQuestionHeading(questionText) {
  return String(questionText || "").replace(
    /^\s*(?:Vra(?:ag)?|Question)\s+\d+(?:\.\d+)?\s*[:.-]?\s*/i,
    ""
  );
}

function formatSubquestionMarks(questionText) {
  return questionText.replace(
    /\((\d+)\)(?=\s*(?:<br\s*\/?>|\n|$))/g,
    "[$1]"
  );
}

function containsHtmlMarkup(value) {
  return /<\/?[a-z][^>]*>/i.test(value);
}

function formatQuestionBody(questionText) {
  let formattedText =
    removeGeneratedQuestionHeading(
      questionText
    ).replace(/\r\n/g, "\n");

  if (!containsHtmlMarkup(formattedText)) {
    formattedText = formattedText.replace(
      /([^\n])\s+(\d+\.\d+\s+)/g,
      "$1\n$2"
    );
  }

  formattedText = formatSubquestionMarks(
    formattedText
  );

  // Never insert <br/> inside tables or SVG. HTML already treats
  // source newlines as whitespace, while <br/> corrupts SVG markup.
  return containsHtmlMarkup(formattedText)
    ? formattedText
    : formattedText.replace(/\n/g, "<br/>");
}

function formatAIQuestion(
  question,
  selectedLanguage
) {
  if (!question) {
    return "";
  }

  const questionLabel =
    selectedLanguage === "af"
      ? "Vraag"
      : "Question";
  const topicText = question.topic
    ? `: ${question.topic}`
    : "";
  const marksText =
    question.marks !== undefined
      ? ` [${question.marks} ${
        selectedLanguage === "af"
          ? "punte"
          : "marks"
      }]`
      : "";

  return `
    <strong>
      ${questionLabel} ${question.question_number}${topicText}${marksText}
    </strong>
    <br/><br/>
    ${formatQuestionBody(
      question.question_text
    )}
  `;
}

export {
  formatAIQuestion,
  formatQuestionBody,
};
